<template>
  <ModalLayout icon="send" :title="`Send creative${meta.multiple ? 's' : ''} to review?`" @close="close">
    <div v-if="!meta.multiple" class="text-review">
      Are you sure you want to send '<strong>{{ meta?.creative?.name }}</strong
      >' to review? You won’t be able to make changes after submission.
    </div>
    <div v-if="meta.multiple" class="text-review">
      Are you sure you want to send all the creatives to review? You won’t be able to make changes after submission.
    </div>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" icon="el-icon-s-promotion" type="primary" :loading="loading" @click="sendToReview"
        >Send to review
      </el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'

export default {
  name: 'SendToReview',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async sendToReview() {
      this.loading = true
      const action = this.meta.multiple ? 'socialBoostCampaign/sendAllCreativesToReview' : 'socialBoostCampaign/sendCreativeToReview'
      const payload = this.meta.multiple ? { flight_id: this.meta.flight_id } : { creative_id: this.meta.creative.id }
      await this.$store.dispatch(action, payload)
      this.$Modal.bus.$emit('reload:creatives')
      this.close()
      this.loading = false
    },
  },
}
</script>
